<template>
    <div id="root" >
      <div id="popup-container" >
        <h2 class="title">手机号快捷校验</h2>
        <span class="sub-title">请开启本机流量进行登录验证</span>
      </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed , watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api/index.js'
import { decryptionECB } from '@/utils/utils.js'
import { showLoadingToast, showToast, Dialog,showConfirmDialog } from 'vant'
import NEOneLogin from '@yidun/quickpass-sdk-one-login-h5';
const store = useStore()
const router = useRouter()
const route = useRoute()
let  neOneLogin = null;
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const handleOnelogininit=()=>{
    const popupContainer = document.querySelector('#popup-container');
  neOneLogin = new NEOneLogin({
  businessId: '170d906bde50421fb73382d96b83be97', 
  mode: 'popup',
  popupContainer,
  phoneInputStyle: 'square',
  elements: ['phone', 'loginButton', 'policy'],
  logoStyles: {
     top: 10,
    },
   phoneStyles: {
      top: 20,
    },
    loginBtnText: '授权登录',
    loginBtnStyles: {
      top: 20,
    },
    policyStyles: {
      top: 20,
      },
    iframeStyles: {
      position: 'absolute',
      left: '0',
      bottom: '0',
       height: '274px',
    },           
});
neOneLogin.on('success', (data) => {
  console.log('success', data);
  api
        .MobileOneKeyLogin({
          token: data.token,
          accessToken: data.accessToken,
          ExhCode: ExhCode.value,
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                    router.push({ path: '/success' })
                }              
            } else {
                sessionStorage.setItem('tabac', 'dl')
              sessionStorage.setItem('mobile', res.data.mobile)
              router.push({ path: '/msg' })
            }
          }
          
        })
});
neOneLogin.on('error', (err) => {
  // err.data 中可以拿到错误信息
  console.log('error', err);
  let errcontent = '';
  let btns = [];
  let data = err.data;
  neOneLogin.dispose();
  neOneLogin = null;
  if (data.code == "20002" || data.code == "30003" || data.code == "40002") {
                    //号码校验失败
                    errcontent = '号码校验失败，您补全的号码不是您当前开启流量的手机号';
                                    
                }
                else if (data.code == "10000" || data.code == "20001" || data.code == "30001" || data.code == "30002" || data.code == "40001") {
                   
                    //取号失败
                    errcontent = '请关闭您手机的无线网络，打开手机的4g/5g流量开关，再点击重试';                    
                }
                else
                {
                    errcontent=data.msg;
                }
               // 使用 Vant 的独立函数而不是 Dialog 对象方法
        showConfirmDialog({
          title: '登录失败',
          message: errcontent,
          confirmButtonText: '重试',
          cancelButtonText: '返回'
        })
        .then(() => {
          // 用户点击"重试"
          console.log('用户选择重试')
          handleOnelogininit() // 重新初始化
        })
        .catch(() => {
          // 用户点击"返回"或关闭弹窗
          console.log('用户选择返回')
          router.go(-1)
        })
      })     

console.log('初始化完成')
neOneLogin.getToken();
}
onMounted(() => {  
    showLoadingToast({
    duration: 1000,
    message: '加载中...',
    forbidClick: true
  })
  handleOnelogininit()  
})
</script>
<style lang="less">
// 防止键盘弹出时页面上移
#root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // 防止页面因键盘弹出而移动
  viewport-fit: cover;
}

#popup-container {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 90%;
  height: 350px;
  transform: translate(-50%, -50%);
  // 添加以下样式防止键盘影响
  transform: translate(-50%, -50%) translateZ(0); // 触发硬件加速
  backface-visibility: hidden;
  will-change: transform;
  // 确保在键盘上方
  z-index: 9999;
  // 添加背景和边框以提高可见性
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.title {
  text-align: center;
  margin-top: 30px;
}

.sub-title {
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: red;
}

.home {
  .main {
    background: #f9f9f9 !important;
  }
}



// 针对移动端的特殊处理
@media screen and (max-width: 768px) {
  #root {
    // 使用 flexbox 布局确保居中
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  #popup-container {
    // 在移动端使用不同的定位方式
    position: absolute;
    margin: 0 auto;
    // 确保在视口中心
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
        
